import { Info } from "@mui/icons-material";
import {
  IconButton,
  Stack,
  TextField,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomDialog from "../CustomDialog";
import { setShowMassage } from "store/sysSlice";
import { useDispatch } from "react-redux";
import NullCheck from "components/NullCheck";

const TextInput = ({
  control,
  rows,
  title,
  name,
  disabled,
  required,
  errors,
  width,
  type,
  validation,
  defaultValue,
  standard,
  autoFocus,
  min,
  max,
  fullWidth,
  readOnly,
  addFlex,
  inputRef,
  onChanged,
  textBold,
  onKeyDown
}) => {
  const dispatch = useDispatch()
  const theme = useTheme();
  const refInput = useRef(null);
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openMassge, setOpenMassge] = useState(false);
  const error = errors ? errors[name]?.ref?.name : false;
  const massge = errors ? errors[name]?.message : "";


  const checkNmber = (value) => {
    let checked = false
    if (!isNaN(value)) {
      if (!value && value === "")
        checked = true

      else if (min || max) {
        if (min && !max && value >= min)
          checked = true

        else if (max && !min && value <= max)
          checked = true

        else if (max && min && value >= min && value <= max)
          checked = true
      }
      else {
        return true
      }
    }
    return checked
  }

  return (
    <Stack
      direction={standard ? "row" : "column"}
      spacing={standard ? 1 : 0}
      padding={0}
      sx={{ flex: addFlex ? 1 : 0, minWidth: 0 }}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{
          required: required ? bt("REQUIRED") : false,
          pattern: {
            value: validation?.regex,
            message: bt(validation?.massge),
          },
        }}
        render={({ field: { onChange, value } }) => (
          <TextField
            defaultValue={defaultValue}
            sx={{ width: width ? width : isMobile ? "100%" : fullWidth ? "100%" : 200 }}
            inputRef={inputRef ? inputRef : refInput}
            fullWidth={fullWidth}
            label={`${required ? "*" : ""}${title ? `${bt(title)}` : ""}`}
            variant={standard ? "standard" : "outlined"}
            error={error === name ? true : false}
            disabled={disabled}
            autoFocus={autoFocus ? true : false}
            multiline={rows ? true : false}
            rows={rows}
            value={value ? value : defaultValue ? defaultValue : ""}
            type={type ?? "text"}
            inputProps={{ min: min, max: max, readOnly: readOnly ?? false }}
            onKeyDown={(e) => {
              if (onKeyDown) onKeyDown()
              e.stopPropagation();
            }}
            InputLabelProps={{
              sx: {
                fontSize: standard ? 14 : 16,
                "&.MuiInputLabel-shrink": {
                  fontSize: standard ? 13 : 15,
                },
              },
            }}
            InputProps={{
              sx: {
                fontWeight: textBold ? 'bold' : 'normal',
                fontSize: standard ? 14 : 16,
                "& .MuiInputBase-input": {
                  padding: standard ? 0 : 1,
                },
              },
              endAdornment: massge ? (
                <Tooltip title={massge}>
                  <IconButton onClick={() => setOpenMassge(true)}>
                    <Info sx={{ color: "error.terxt" }} fontSize="small" />
                  </IconButton>
                </Tooltip>
              ) : null,
            }}
            onChange={(e) => {
              const v = e.target.value
              if (onChanged) onChanged(v)

              if (isNaN(v) === false) {
                if (checkNmber(v)) onChange(v)
                else {
                  if (max && !min)
                    return dispatch(setShowMassage({
                      massage: `${bt('NUMBER_MUST_BE_LESS_THAN')} ${max + 1}`,
                      type: "info"
                    }));
                  else if (min && !max)
                    return dispatch(setShowMassage({
                      massage: `${bt('NUMBER_MUST_BE_GREATER_THAN')} ${min + 1}`,
                      type: "info"
                    }));
                  else if (min && max)
                    return dispatch(setShowMassage({
                      massage: `${bt('NUMBER_MUST_BE_BETWEEN')} ${min} - ${max}`,
                      type: "info"
                    }));
                }
              }

              else onChange(e.target.value)
            }}
          />
        )}
      />

      <NullCheck valueForCheck={massge}>
        <CustomDialog
          title="ERROR"
          open={openMassge}
          width={300}
          onClose={() => setOpenMassge(false)}
          closeBtn="CLOSE"
        >
          <Stack alignItems="center">
            {massge}
          </Stack>
        </CustomDialog>
      </NullCheck>

    </Stack>
  );
};
export default TextInput;
